import { Flex, UnstyledButton } from "@mantine/core";

import { IconPencil } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";
import { Gestation } from "@/pregnancy";

interface PostPartumTrackerProps {
  postpartumAge: Gestation;
  contentClassName?: string;
  iconClassName?: string;
  canEdit: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  rowClassName?: string;
}

const PostPartumTracker = ({
  postpartumAge,
  onClick,
  contentClassName,
  iconClassName,
  rowClassName,
  canEdit,
}: PostPartumTrackerProps) => {
  const { weeks, days } = postpartumAge;

  return (
    <UnstyledButton
      onClick={onClick}
      disabled={!canEdit}
      className={rowClassName}
      data-testid="postpartum-tracker-button"
    >
      <Flex w="100%" align="center" justify="space-between">
        <Flex gap="xs" wrap="nowrap" align="center" className={contentClassName}>
          <TextWrapper m={0} size="sm" c="gray.6" variant="bold">
            PP
          </TextWrapper>
          <TextWrapper m={0} size="sm" c="dark.9" variant="bold">
            {weeks}w {days}d
          </TextWrapper>
        </Flex>
        {canEdit && (
          <span className={iconClassName}>
            <IconPencil size={18} />
          </span>
        )}
      </Flex>
    </UnstyledButton>
  );
};

export default PostPartumTracker;
